/** French candidate strings — shared. Key = the exact English text passed to t(), value = French. */
const fr = {
  // ── Common buttons ──
  Close: 'Fermer',
  Cancel: 'Annuler',
  'Try again': 'Réessayer',

  // ── LeaveScreeningModal / usePreventBack ──
  'Leave this page?': 'Quitter cette page ?',
  'Your progress may be affected': 'Votre progression peut être affectée',
  'Stay on page': 'Rester sur la page',
  'Leave anyway': 'Quitter quand même',
  "You're in the middle of your screening. Closing or leaving this page may interrupt your progress and could affect your application. If possible, please continue until you see the final confirmation screen.":
    'Votre présélection est en cours. Fermer ou quitter cette page peut interrompre votre progression et affecter votre candidature. Dans la mesure du possible, continuez jusqu’à l’écran de confirmation final.',

  // ── DeviceCheckModal ──
  Microphone: 'Microphone',
  Camera: 'Caméra',
  'Device Check': 'Vérification de l’appareil',
  "Let's make sure everything works": 'Vérifions que tout fonctionne',
  'Camera & Microphone Check': 'Vérification de la caméra et du microphone',
  'Microphone Check': 'Vérification du microphone',
  "We'll quickly test your camera and microphone to make sure the interview runs smoothly.":
    'Nous allons rapidement tester votre caméra et votre microphone pour que l’entretien se déroule sans problème.',
  "We'll quickly test your microphone to make sure the interview runs smoothly.":
    'Nous allons rapidement tester votre microphone pour que l’entretien se déroule sans problème.',
  'Your browser will ask for permission — please click': 'Votre navigateur va demander une autorisation — veuillez cliquer sur',
  '"Allow"': '« Autoriser »',
  'Start Device Check': 'Lancer la vérification',
  'Playing back...': 'Lecture…',
  'Listening...': 'Écoute…',
  'Working great!': 'Fonctionne parfaitement !',
  '✓ Audio detected! Hold on...': '✓ Son détecté ! Patientez…',
  'Speak or make a sound to test...': 'Parlez ou faites un bruit pour tester…',
  'Recording a short clip...': 'Enregistrement d’un court extrait…',
  'Playing back your audio — can you hear yourself?': 'Lecture de votre enregistrement — vous entendez-vous ?',
  'Playing...': 'Lecture…',
  'Your microphone is working perfectly.': 'Votre microphone fonctionne parfaitement.',
  'Checking...': 'Vérification…',
  'Looking good!': 'Tout est en ordre !',
  Ready: 'Opérationnelle',
  "Camera is working. Make sure you're well lit and centered.":
    'La caméra fonctionne. Veillez à avoir un bon éclairage et à rester au centre de l’image.',
  'All checks passed!': 'Toutes les vérifications sont réussies !',
  "You're all set. Click below to start your interview.": 'Tout est en ordre. Cliquez ci-dessous pour commencer votre entretien.',
  'Start Interview': 'Commencer l’entretien',
  'Testing...': 'Test en cours…',
  'Retry Tests': 'Relancer les tests',
  'Browser Not Supported': 'Navigateur non pris en charge',
  "Your browser doesn't support camera and microphone access. Please use a modern browser like":
    'Votre navigateur ne permet pas l’accès à la caméra et au microphone. Veuillez utiliser un navigateur récent comme',
  or: 'ou',
  'Go Back': 'Retour',
  // error card
  'How to fix on {deviceName} ({browserName}):': 'Comment corriger sur {deviceName} ({browserName}) :',
  'How to fix:': 'Comment corriger :',
  'Look for a 🔒 lock icon in the address bar': 'Repérez l’icône de cadenas 🔒 dans la barre d’adresse',
  'Find permission settings for this site': 'Ouvrez les paramètres d’autorisation de ce site',
  'Allow camera and microphone access': 'Autorisez l’accès à la caméra et au microphone',
  'Refresh this page': 'Actualisez cette page',
  'Refresh Page': 'Actualiser la page',
  'After changing the permission': 'Après avoir modifié l’autorisation',
  'your browser': 'votre navigateur',
  Desktop: 'Ordinateur',
  'your device': 'votre appareil',
  // device errors
  '{device} permission denied': '{device} : autorisation refusée',
  'You blocked {deviceLower} access. Follow the steps below for your device to fix it.':
    'Vous avez bloqué l’accès à votre {deviceLower}. Suivez les étapes ci-dessous pour corriger cela sur votre appareil.',
  'No {deviceLower} found': 'Aucun périphérique détecté ({deviceLower})',
  "We couldn't detect a {deviceLower}. Make sure your device's {deviceLower} isn't disabled in system settings.":
    'Impossible de détecter votre {deviceLower}. Vérifiez dans les paramètres système que l’accès à votre {deviceLower} n’est pas désactivé.',
  "We couldn't detect a {deviceLower} connected to your computer. Please plug one in and try again.":
    'Aucun périphérique ({deviceLower}) n’est connecté à votre ordinateur. Branchez-en un et réessayez.',
  '{device} is in use': '{device} : déjà en cours d’utilisation',
  'Your {deviceLower} is being used by another app (Zoom, Teams, Meet, etc.). Close those apps and try again.':
    'Une autre application (Zoom, Teams, Meet, etc.) utilise votre {deviceLower}. Fermez ces applications et réessayez.',
  '{device} not compatible': '{device} : non compatible',
  "The selected {deviceLower} doesn't meet the requirements. Try a different device.":
    'Le périphérique sélectionné ({deviceLower}) ne répond pas aux exigences. Essayez un autre périphérique.',
  '{device} access cancelled': '{device} : accès annulé',
  'The permission popup was dismissed. Please try again and tap "Allow" when your browser asks.':
    'La fenêtre d’autorisation a été fermée. Veuillez réessayer et touchez « Autoriser » lorsque votre navigateur vous le demande.',
  '{device} error': '{device} : erreur',
  'Something went wrong accessing your {deviceLower}. Please try again.':
    'Un problème est survenu lors de l’accès à votre {deviceLower}. Veuillez réessayer.',
  'Microphone disconnected': 'Microphone déconnecté',
  'Your microphone was disconnected during the test. Please reconnect it and try again.':
    'Votre microphone a été déconnecté pendant le test. Veuillez le reconnecter et réessayer.',
  'No audio detected': 'Aucun son détecté',
  "We couldn't pick up any sound. Please speak or make a noise, check your microphone is not muted, and try again.":
    'Nous n’avons capté aucun son. Parlez ou faites un bruit, vérifiez que votre microphone n’est pas coupé, puis réessayez.',
  'Camera disconnected': 'Caméra déconnectée',
  'Your camera was disconnected during the test. Please reconnect it and try again.':
    'Votre caméra a été déconnectée pendant le test. Veuillez la reconnecter et réessayer.',
  'Camera not working': 'La caméra ne fonctionne pas',
  "The camera was detected but isn't providing video. Try a different camera or restart your browser.":
    'La caméra a été détectée mais ne transmet pas d’image. Essayez une autre caméra ou redémarrez votre navigateur.',
  // permission fix steps (browser menu names as shown in French browsers)
  'Open the Settings app on your {model}': 'Ouvrez l’app Réglages sur votre {model}',
  'Scroll down and tap "Safari"': 'Faites défiler vers le bas et touchez « Safari »',
  'Tap "{device}" and select "Allow"': 'Touchez « {device} » et sélectionnez « Autoriser »',
  'Come back to this page and tap "Try again"': 'Revenez sur cette page et touchez « Réessayer »',
  'Scroll down and tap "{browser}"': 'Faites défiler vers le bas et touchez « {browser} »',
  'Make sure "{device}" is set to "Allow"': 'Vérifiez que « {device} » est réglé sur « Autoriser »',
  'Tap the 🔒 lock icon in the address bar at the top': 'Touchez l’icône de cadenas 🔒 dans la barre d’adresse en haut',
  'Tap "Permissions" or "Site settings"': 'Touchez « Autorisations » ou « Paramètres des sites »',
  'Find "{device}" and change it to "Allow"': 'Trouvez « {device} » et choisissez « Autoriser »',
  'The page will refresh automatically': 'La page s’actualisera automatiquement',
  'Tap the ☰ menu icon (three lines) at the bottom right': 'Touchez l’icône de menu ☰ (trois traits) en bas à droite',
  'Tap "Settings" → "Sites and downloads"': 'Touchez « Paramètres » → « Sites et téléchargements »',
  'Tap "{device}" and set it to "Allow"': 'Touchez « {device} » et réglez-le sur « Autoriser »',
  'Go back to this page and tap "Try again"': 'Revenez sur cette page et touchez « Réessayer »',
  'Tap the 🔒 lock icon in the address bar': 'Touchez l’icône de cadenas 🔒 dans la barre d’adresse',
  'Tap "Edit Site Permissions"': 'Touchez « Modifier les autorisations du site »',
  'Toggle "{device}" to allowed': 'Activez l’autorisation « {device} »',
  'Tap "Try again" below': 'Touchez « Réessayer » ci-dessous',
  'Tap the Brave shield icon (lion) in the address bar': 'Touchez l’icône du bouclier Brave (lion) dans la barre d’adresse',
  'Tap "Advanced controls" or "Site settings"': 'Touchez « Contrôles avancés » ou « Paramètres des sites »',
  'Find "{device}" and set to "Allow"': 'Trouvez « {device} » et réglez sur « Autoriser »',
  'Tap the address bar, then the 🔒 lock icon': 'Touchez la barre d’adresse, puis l’icône de cadenas 🔒',
  'Tap "Site settings"': 'Touchez « Paramètres des sites »',
  'Set "{device}" to "Allow"': 'Réglez « {device} » sur « Autoriser »',
  'Tap the lock or info icon in the address bar': 'Touchez l’icône de cadenas ou d’information dans la barre d’adresse',
  'Go to "Site settings" or "Permissions"': 'Allez dans « Paramètres des sites » ou « Autorisations »',
  'Allow "{device}" access': 'Autorisez l’accès « {device} »',
  'Click "Safari" in the top menu bar → "Settings" (or "Preferences")':
    'Cliquez sur « Safari » dans la barre de menus → « Réglages » (ou « Préférences »)',
  'Go to the "Websites" tab': 'Ouvrez l’onglet « Sites web »',
  'Click "{device}" in the left sidebar': 'Cliquez sur « {device} » dans la barre latérale gauche',
  'Find this website and change permission to "Allow"': 'Trouvez ce site et changez l’autorisation en « Autoriser »',
  'Close Settings and refresh this page': 'Fermez les Réglages et actualisez cette page',
  'Click the 🔒 lock icon in the address bar (top left)':
    'Cliquez sur l’icône de cadenas 🔒 dans la barre d’adresse (en haut à gauche)',
  'Click "Site settings"': 'Cliquez sur « Paramètres des sites »',
  'Find "{device}" and change from "Block" to "Allow"': 'Trouvez « {device} » et passez de « Bloquer » à « Autoriser »',
  'Close the tab and refresh this page': 'Fermez l’onglet et actualisez cette page',
  'Also check: System Settings → Privacy & Security → {device} → Enable for Chrome':
    'Vérifiez aussi : Réglages Système → Confidentialité et sécurité → {device} → Activer pour Chrome',
  'Click the 🔒 lock icon in the address bar': 'Cliquez sur l’icône de cadenas 🔒 dans la barre d’adresse',
  'Click the arrow next to "Connection secure"': 'Cliquez sur la flèche à côté de « Connexion sécurisée »',
  'Click "More Information" → "Permissions" tab': 'Cliquez sur « Plus d’informations » → onglet « Permissions »',
  'Find "{device}" and uncheck "Block" / check "Allow"': 'Trouvez « {device} » et décochez « Bloquer » / cochez « Autoriser »',
  'Click "Site permissions"': 'Cliquez sur « Autorisations du site »',
  'Find "{device}" and change to "Allow"': 'Trouvez « {device} » et choisissez « Autoriser »',
  'Also check: System Settings → Privacy & Security → {device} → Enable for Edge':
    'Vérifiez aussi : Réglages Système → Confidentialité et sécurité → {device} → Activer pour Edge',
  'Click the site icon in the address bar': 'Cliquez sur l’icône du site dans la barre d’adresse',
  'Click "More Permissions"': 'Cliquez sur « Plus d’autorisations »',
  'Toggle "{device}" to "Allow"': 'Réglez « {device} » sur « Autoriser »',
  'Change "{device}" from "Block" to "Allow"': 'Passez « {device} » de « Bloquer » à « Autoriser »',
  'Also check: System Settings → Privacy & Security → {device}':
    'Vérifiez aussi : Réglages Système → Confidentialité et sécurité → {device}',
  'Click the 🔒 lock icon in the address bar (top left of the URL)':
    'Cliquez sur l’icône de cadenas 🔒 dans la barre d’adresse (à gauche de l’URL)',
  'Close the Settings tab and refresh this page': 'Fermez l’onglet Paramètres et actualisez cette page',
  'Click the "X" next to the blocked permission, or': 'Cliquez sur le « X » à côté de l’autorisation bloquée, ou',
  'Uncheck "Block" next to "{device}"': 'Décochez « Bloquer » à côté de « {device} »',
  'Find "{device}" permission and set to "Allow"': 'Trouvez l’autorisation « {device} » et réglez-la sur « Autoriser »',
  'Also check: Windows Settings → Privacy → {device}': 'Vérifiez aussi : Paramètres Windows → Confidentialité → {device}',
  'Change "{device}" to "Allow"': 'Réglez « {device} » sur « Autoriser »',
  'Find the {deviceLower} permission and click "Allow"': 'Trouvez l’autorisation « {deviceLower} » et cliquez sur « Autoriser »',
  'Look for a 🔒 lock or camera/microphone icon in the address bar':
    'Repérez l’icône de cadenas 🔒 ou de caméra/microphone dans la barre d’adresse',
  'Find the {deviceLower} permission setting': 'Trouvez le paramètre d’autorisation « {deviceLower} »',
  'Change it from "Block" to "Allow"': 'Passez-le de « Bloquer » à « Autoriser »',
  'Refresh this page and try again': 'Actualisez cette page et réessayez',
};

export default fr;
